import(/* webpackMode: "eager" */ "/vercel/path0/components/tools/roi-calculator/roi-calculator.tsx")